export var applicationBulkApplicationFileDownload = {
  setup: function() {
    let selected = $('article.selected')[0];
    selected && selected.scrollIntoView();
  }
};
